/* eslint-disable unicorn/filename-case -- kebab-case per docs/conventions/core.md:
   this file exports a function, not a React component. */

/** Hands a generated file to the browser's download flow via a throwaway object URL. */
export function downloadBlob(blob: Blob, fileName: string): void {
  const objectUrl = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = objectUrl;
  anchor.download = fileName;
  document.body.append(anchor);
  anchor.click();
  anchor.remove();
  // anchor.click() schedules the download asynchronously; revoking on the next tick avoids racing the browser's own blob capture.
  setTimeout(() => URL.revokeObjectURL(objectUrl), 0);
}
